export function toDateInputValue(date) {
    const local = date
    local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
}

export function checkCategoryFromDate(dateOfBirth, categories) {

    if (dateOfBirth) {
        /*

        console.log(`${birthDate.getHours()}-${birthDate.getMinutes()}-${birthDate.getSeconds()}`)
        const nowYear = new Date();

        const dateNow = new Date();
        dateNow.setDate(1);
        dateNow.setMonth(11);
        dateNow.setFullYear(nowYear.getUTCFullYear());
        dateNow.setHours(1);
        dateNow.setMinutes(0);
        dateNow.setSeconds(0);
        dateNow.setMilliseconds(0);
        console.log(`${dateNow.getHours()}-${dateNow.getMinutes()}-${dateNow.getSeconds()}`)

        var diff = (dateNow.getTime() - birthDate.getTime()) / 1000;
        // Convert the difference from milliseconds to days
        diff /= (60 * 60 * 24);
        // Calculate the approximate number of years by dividing the difference in days by the average number of days in a year (365.25)

        const yearDiffrence = Math.abs(Math.floor(diff / 365.25));
        console.log(diff / 365.25)
        */


        const birthDate = new Date(dateOfBirth);

        const dateNow = new Date();

        // check if current month = december
        if (dateNow.getMonth() !== 11) {
            // set datenow to next year
            dateNow.setFullYear(dateNow.getFullYear() -1);
        }
        const yearDiffrence = dateNow.getFullYear()-birthDate.getFullYear();
        console.log(yearDiffrence)
        const category = categories?.find(c => yearDiffrence >= c.fromYear && yearDiffrence <= c.toYear);
        return category?.title;
    }
    return " ";
}
